"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TimeObject {
    constructor({ hours, minutes, seconds }) {
        this.toJSON = () => ({
            hours: this.hours,
            minutes: this.minutes,
            seconds: this.seconds,
        });
        this.hours = hours;
        this.minutes = minutes;
        this.seconds = seconds;
    }
}
TimeObject.fromJSON = (json) => {
    const { hours, minutes, seconds } = Object.assign({}, json);
    if (typeof hours !== 'number')
        throw new Error('.hours must be a number');
    if (typeof minutes !== 'number')
        throw new Error('.minutes must be a number');
    if (typeof seconds !== 'number')
        throw new Error('.seconds must be a number');
    return new TimeObject({
        hours,
        minutes,
        seconds,
    });
};
exports.default = TimeObject;
